export default __webpack_public_path__ + "static/media/log-out_white.3ecc7d17.svg";